export default {seo:{title:'Account Modification',description:null},title:'Account & Password'};